import React from 'react';
import AccountList from 'components/adm/account/accountList';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import styled from 'styled-components';
import UnitLoading from 'components/parts/loading/unitLoading';
import Message from 'components/parts/message';

/**
 * 管理者アカウント一覧画面
*/
const AdmAccounts = (props) => {
  return (
    <div className="col-10 pt-3 pb-3">
      <UnitLoading/>
      <Div>
        <Link to='/adm/account/regist' data-testid='link-to-regist'>
          <RegistButton data-testid='regist-button'>Add</RegistButton>
        </Link>
      </Div>
      <Message/>
      {/* 管理者アカウント一覧 */}
      <AccountList {...props}/>
    </div>
  );
};
const Div = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
`;
const RegistButton = styled(Button)`
  margin-right: 20px;
`;
export default AdmAccounts;